import { gql } from "@apollo/client";

export const CreateInstalledBaseIotReportSubscription = gql`
    mutation CreateInstalledBaseIotReportSubscription ($clientId: ID!, $input: InstalledBaseIotReportSubscriptionInput!) {
        createInstalledBaseIotReportSubscription(clientId: $clientId, input: $input) {
            id
            inApp
            mail
            push
            insert
            update
            client {
                id
                name
            }
        }
    }
`;
